import { Theme } from '@mui/material/styles'

const muiFormLabel = (theme: Theme) => {
  return {
    styleOverrides: {
      asterisk: {
        color: theme.palette.error.main
      }
    }
  }
}

export default muiFormLabel
